<div class="appContentsContainer">
  <form
    [formGroup]="maintenancePatronesWltp"
    class="formGroup container longDetail"
  >
    <div class="collapseButtonContainer">
      <div class="pageTitle noButton">Datos Cabecera</div>
    </div>
    <div class="halfGroup">
      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwTipoHomol"> Tipo: </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwTipoHomol"
              type="text"
              formControlName="pwTipoHomol"
              [readonly]="true"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwMotor"> Motor: </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwMotor"
              type="text"
              formControlName="pwMotor"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwTipoCambio"> Cambio: </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwTipoCambio"
              type="text"
              formControlName="pwTipoCambio"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwCorrelativo"> Correlativo: </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwCorrelativo"
              type="text"
              formControlName="pwCorrelativo"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="collapseButtonContainer">
      <div class="pageTitle noButton">Datos Generales</div>
    </div>

    <div class="halfGroup">
      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwClaseHibrido"> Clase híbrido: </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwClaseCibrido"
              type="text"
              formControlName="pwClaseHibrido"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwMasaTest"> Masa test en KG: </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwMasaTest"
              type="text"
              formControlName="pwMasaTest"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwAreaFrontal"> Área frontal m2: </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwAreaFrontal"
              type="text"
              formControlName="pwAreaFrontal"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwCoefic1"> Coeficiente carga 1: </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwCoefic1"
              type="text"
              formControlName="pwCoefic1"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwCoefic2"> Coeficiente carga 2: </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwCoefic2"
              type="text"
              formControlName="pwCoefic2"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwCoefic3"> Coeficiente carga 3: </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwCoefic3"
              type="text"
              formControlName="pwCoefic3"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="collapseButtonContainer">
      <div class="pageTitle noButton">RDE</div>
    </div>

    <div class="halfGroup">
      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwRdeNoxComp"> NOX Completo: </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwRdeNoxComp"
              type="text"
              formControlName="pwRdeNoxComp"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwRdeNoxUrb"> Nox Urbano: </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwRdeNoxUrb"
              type="text"
              formControlName="pwRdeNoxUrb"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwRdeComPart"> Completo partículas: </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwRdeComPart"
              type="text"
              formControlName="pwRdeComPart"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwRdeUrbPart"> Urbano partículas: </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwRdeUrbPart"
              type="text"
              formControlName="pwRdeUrbPart"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="collapseButtonContainer">
      <div class="pageTitle noButton">NEFZ - Emisiones y consumos</div>
    </div>
    <div class="halfGroup">
      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwNfCaeUrb"> Emis.CO2 urb.(Gasol/Diesel) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwNfCaeUrb"
              type="text"
              formControlName="pwNfCaeUrb"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwNfEmiSin"> Cons.Urb.(Litros) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwNfEmiSin"
              type="text"
              formControlName="pwNfEmiSin"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwNfCaeUrg"> Emis.CO2 urb.(Gas) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwNfCaeUrg"
              type="text"
              formControlName="pwNfCaeUrg"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwNfEmiSim"> Cons.Urb.(m3) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwNfEmiSim"
              type="text"
              formControlName="pwNfEmiSim"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwNfEmCo2U"> Emis.CO2 urb.(Otro) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwNfEmCo2U"
              type="text"
              formControlName="pwNfEmCo2U"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwNfConUro"> Cons.Urb.(Otro) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwNfConUro"
              type="text"
              formControlName="pwNfConUro"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwNfCaeExt"> Emis.Co2 extraurb.(Gasol/Diesel) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwNfCaeExt"
              type="text"
              formControlName="pwNfCaeExt"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwNfEmiCau"> Cons.Extraurb.(Litros) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwNfEmiCau"
              type="text"
              formControlName="pwNfEmiCau"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwNfCaeExg"> Emis.Co2 extraurb.(Gas) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwNfCaeExg"
              type="text"
              formControlName="pwNfCaeExg"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwNfEmiCam"> Cons.Extraurb.(m3) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwNfEmiCam"
              type="text"
              formControlName="pwNfEmiCam"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwNfEmCo2E"> Emis.Co2 extraurb.(Otro) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwNfEmCo2E"
              type="text"
              formControlName="pwNfEmCo2E"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwNfConExo"> Cons.Extraurb.(Otro) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwNfConExo"
              type="text"
              formControlName="pwNfConExo"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwNfEmiCo2"> Emis.CO2 mixto (Gasol/Diesel) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwNfEmiCo2"
              type="text"
              formControlName="pwNfEmiCo2"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwNfEmiSko"> Cons.Combinado(Litros) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwNfEmiSko"
              type="text"
              formControlName="pwNfEmiSko"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwNfEmCo2G"> Emis.CO2 comb(Gas) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwNfEmCo2G"
              type="text"
              formControlName="pwNfEmCo2G"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwNfEmiSkm"> Cons.Combinado(m3) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwNfEmiSkm"
              type="text"
              formControlName="pwNfEmiSkm"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwNfEmCo2C"> Emis.CO2 comb(Otro) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwNfEmCo2C"
              type="text"
              formControlName="pwNfEmCo2C"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwNfConCoo"> Cons.Combinado(Otro) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwNfConCoo"
              type="text"
              formControlName="pwNfConCoo"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwNfCo2Las">
                Emis.CO2 Mixto last (Gasol / Diesel)
              </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwNfCo2Las"
              type="text"
              formControlName="pwNfCo2Las"
              maxlength="32"
            />
            <div class="supIndex">*</div>
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwNfSkolas"> Cons.Combinado Last. (Litros) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwNfSkolas"
              type="text"
              formControlName="pwNfSkolas"
              maxlength="32"
            />
            <div class="supIndex">*</div>
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwNfCoGLas"> Emis.CO2 Comb.Last. (Gas) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwNfCoGLas"
              type="text"
              formControlName="pwNfCoGLas"
              maxlength="32"
            />

            <div class="supIndex">*</div>
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwNfEmiLas"> Cons.Comb. Last.(m3) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwNfEmiLas"
              type="text"
              formControlName="pwNfEmiLas"
              maxlength="32"
            />
            <div class="supIndex">*</div>
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwNfEmCo2L"> Emis.CO2 comb. Last (Otro) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwNfEmCo2L"
              type="text"
              formControlName="pwNfEmCo2L"
              maxlength="32"
            />
            <div class="supIndex">*</div>
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwNfConLao"> Cons.Comb. Last. (Otro) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwNfConLao"
              type="text"
              formControlName="pwNfConLao"
              maxlength="32"
            />
            <div class="supIndex">*</div>
          </div>
        </div>
      </div>
    </div>

    <div class="collapseButtonContainer">
      <div class="pageTitle noButton">WLTP - Emisiones y consumos</div>
    </div>

    <div class="halfGroup">
      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWlAhoDie">
                Ahorro.E.CO2 Eco-Inno (Gasol/Diesel)
              </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWlAhoDie"
              type="text"
              formControlName="pwWlAhoDie"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWco2Mdgd"> Medium Emis.Co2 (Gasol/Diesel) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWco2Mdgd"
              type="text"
              formControlName="pwWco2Mdgd"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWlCo2Las">
                Emis.Co2 Mixto Last. (Gas/Diesel)
              </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWlCo2Las"
              type="text"
              formControlName="pwWlCo2Las"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWlConEhl"> Extrahigh consumo (Litros) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWlConEhl"
              type="text"
              formControlName="pwWlConEhl"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWco2Mdga"> Medium Emis. CO2 (Gas) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWco2Mdga"
              type="text"
              formControlName="pwWco2Mdga"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWlCo2Lag"> Emi.CO2 Mixto Last.(Gas) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWlCo2Lag"
              type="text"
              formControlName="pwWlCo2Lag"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWlConEhg"> Extrahigh cons. (Litros Gas) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWlConEhg"
              type="text"
              formControlName="pwWlConEhg"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWCo2Mdot"> Medium emis.CO2 (Otro) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWCo2Mdot"
              type="text"
              formControlName="pwWCo2Mdot"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWlCo2Lot"> Emi.CO2 mixto last. (Otro) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWlCo2Lot"
              type="text"
              formControlName="pwWlCo2Lot"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWlConEho"> Extrahigh Cons. (Litros Otro) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWlConEho"
              type="text"
              formControlName="pwWlConEho"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwRaElePur"> Rango eléctricos puros </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwRaElePur"
              type="text"
              formControlName="pwRaElePur"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwRaElurAh">
                Rango eléctrico urbano eaer híbrido
              </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwRaElurAh"
              type="text"
              formControlName="pwRaElurAh"
              maxlength="32"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="halfGroup">
      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWlAhoGas"> Ahorro.E.CO2 Eco-Inno (Gas) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWlAhoGas"
              type="text"
              formControlName="pwWlAhoGas"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWco2Higd"> High emis.CO2 (Gasol/Diesel) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWco2Higd"
              type="text"
              formControlName="pwWco2Higd"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWlConLwl"> Low consumo (Litros) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWlConLwl"
              type="text"
              formControlName="pwWlConLwl"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWlConCol"> Consumos mixto (Litros) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWlConCol"
              type="text"
              formControlName="pwWlConCol"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWco2Higa"> High emis.CO (Gas) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWco2Higa"
              type="text"
              formControlName="pwWco2Higa"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWlConLwg"> Low consumo (Litros Gas) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWlConLwg"
              type="text"
              formControlName="pwWlConLwg"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWlConCog"> Consumo mixto (Litros Gas) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWlConCog"
              type="text"
              formControlName="pwWlConCog"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWCo2Hiot"> High emis.CO2 (Otros) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWCo2Hiot"
              type="text"
              formControlName="pwWCo2Hiot"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWlConLwo"> Low consumo (Litros Otro) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWlConLwo"
              type="text"
              formControlName="pwWlConLwo"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWlConCoo"> Consumo mixto (Litros Otro) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWlConCoo"
              type="text"
              formControlName="pwWlConCoo"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwRaElurPu">
                Rango eléctrico urb. eléctricos puros
              </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwRaElurPu"
              type="text"
              formControlName="pwRaElurPu"
              maxlength="32"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="halfGroup">
      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWlAhoOtr"> Ahorro.E.CO2 Eco-Inno (Otro) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWlAhoOtr"
              type="text"
              formControlName="pwWlAhoOtr"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWco2Ehgd">
                Extrahigh emis. CO2 (Gasol / Diesel)
              </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWco2Ehgd"
              type="text"
              formControlName="pwWco2Ehgd"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWlConMdl"> Medium consumo (Litro) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWlConMdl"
              type="text"
              formControlName="pwWlConMdl"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWlConLal"> Consumos mixto last. (Litros) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWlConLal"
              type="text"
              formControlName="pwWlConLal"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWco2Ehga"> Extrahigh emis.CO2 (Gas) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWco2Ehga"
              type="text"
              formControlName="pwWco2Ehga"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWlConMdg"> Medium consumo (Litros Gas) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWlConMdg"
              type="text"
              formControlName="pwWlConMdg"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWlConLag"> Consumo mixto Last. (Litros Gas) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWlConLag"
              type="text"
              formControlName="pwWlConLag"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWCo2Ehot"> Extrahigh emis.CO2 (Otro) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWCo2Ehot"
              type="text"
              formControlName="pwWCo2Ehot"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWlConMdo"> Medium consumo (Litros Otro) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWlConMdo"
              type="text"
              formControlName="pwWlConMdo"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWlConLao"> Consumo mixto last (Litros Otro) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWlConLao"
              type="text"
              formControlName="pwWlConLao"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwCoElecAh"> Consumo eléctrico ecac híbridos</label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwCoElecAh"
              type="text"
              formControlName="pwCoElecAh"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWco2Lwgd">
                Low emisiones CO2 (Gasol / Diesel)
              </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWco2Lwgd"
              type="text"
              formControlName="pwWco2Lwgd"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWlEmiCo2"> Emis.CO2 mixto (Gasol/Diesel) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWlEmiCo2"
              type="text"
              formControlName="pwWlEmiCo2"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWlConHil"> High consumo (Litros) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWlConHil"
              type="text"
              formControlName="pwWlConHil"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWco2Lwga"> Low emisiones CO2 (Gas) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWco2Lwga"
              type="text"
              formControlName="pwWco2Lwga"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWlemCo2g"> Emis.CO2 mixto (Gas) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWlemCo2g"
              type="text"
              formControlName="pwWlemCo2g"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWlConHig"> High consumo (Litros Gas) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWlConHig"
              type="text"
              formControlName="pwWlConHig"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWCo2Lwot"> Low emisiones CO2 (Otro) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWCo2Lwot"
              type="text"
              formControlName="pwWCo2Lwot"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWlEmCo2o"> Emisiones CO2 mixto (Otro) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWlEmCo2o"
              type="text"
              formControlName="pwWlEmCo2o"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwWlConHio"> High consumo (Litros Otro) </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwWlConHio"
              type="text"
              formControlName="pwWlConHio"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwCoElePur">
                Consumo eléctrico eléctricos puros
              </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwCoElePur"
              type="text"
              formControlName="pwCoElePur"
              maxlength="32"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwRaEleEah"> Consumo eléctrico ecac híbridos </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwRaEleEah"
              type="text"
              formControlName="pwRaEleEah"
              maxlength="32"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="collapseButtonContainer">
      <div class="pageTitle noButton">Ejes y ruedas</div>
    </div>
    <div class="halfGroup">
      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwDeNeume1"> Neumáticos eje 1 </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwDeNeume1"
              type="text"
              formControlName="pwDeNeume1"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwDeLlane1"> Llantas eje 1 </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwDeLlane1"
              type="text"
              formControlName="pwDeLlane1"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwDeNeume2"> Neumáticos eje 2 </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwDeNeume2"
              type="text"
              formControlName="pwDeNeume2"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwDeLlane2"> Llantas eje 2 </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwDeLlane2"
              type="text"
              formControlName="pwDeLlane2"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwResistRodEje1">
                Clase resistencia rodadura eje 1
              </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwResistRodEje1"
              type="text"
              formControlName="pwResistRodEje1"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwResistRodEje2">
                Clase resistencia rodadura eje 2
              </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwResistRodEje2"
              type="text"
              formControlName="pwResistRodEje2"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>

      <div class="row compressedRow longListTextarea">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwDeObser1"> Observaciones 1 </label>
            </div>
          </div>
          <div class="inputContainer">
            <textarea
              id="pwDeObser1"
              type="textarea"
              formControlName="pwDeObser1"
              maxlength="128"
              maxlength="32"
              [readonly]="true"
            ></textarea>
          </div>
        </div>
      </div>

      <div class="row compressedRow longListTextarea">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwDeObser2"> Observaciones 2 </label>
            </div>
          </div>
          <div class="inputContainer extraHeightRow">
            <textarea
              id="pwDeObser2"
              type="textarea"
              formControlName="pwDeObser2"
              maxlength="128"
              maxlength="32"
              [readonly]="true"
            ></textarea>
          </div>
        </div>
      </div>

      <div class="row compressedRow longListTextarea">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwDeObser3"> Observaciones 3 </label>
            </div>
          </div>
          <div class="inputContainer">
            <textarea
              id="pwDeObser3"
              type="textarea"
              formControlName="pwDeObser3"
              maxlength="128"
              maxlength="32"
              [readonly]="true"
            ></textarea>
          </div>
        </div>
      </div>

      <div class="row compressedRow longListTextarea">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwDeObser4"> Observaciones 4 </label>
            </div>
          </div>
          <div class="inputContainer extraHeightRow">
            <textarea
              id="pwDeObser4"
              type="textarea"
              formControlName="pwDeObser4"
              maxlength="128"
              maxlength="32"
              [readonly]="true"
            ></textarea>
          </div>
        </div>
      </div>

      <div class="row compressedRow longListTextarea">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwReNeume1"> Resto neumáticos eje 1 </label>
            </div>
          </div>
          <div class="inputContainer">
            <textarea
              id="pwReNeume1"
              type="textarea"
              formControlName="pwReNeume1"
              maxlength="128"
              maxlength="32"
              [readonly]="true"
            ></textarea>
          </div>
        </div>
      </div>

      <div class="row compressedRow longListTextarea">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwReNeume2"> Resto neumáticos eje 2 </label>
            </div>
          </div>
          <div class="inputContainer">
            <textarea
              id="pwReNeume2"
              type="textarea"
              formControlName="pwReNeume2"
              maxlength="128"
              maxlength="32"
              [readonly]="true"
            ></textarea>
          </div>
        </div>
      </div>

      <div class="row compressedRow longListTextarea">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwReLlane1"> Resto llantas eje 1 </label>
            </div>
          </div>
          <div class="inputContainer extraHeightRow">
            <textarea
              id="pwReLlane1"
              type="textarea"
              formControlName="pwReLlane1"
              maxlength="128"
              maxlength="32"
              [readonly]="true"
            ></textarea>
          </div>
        </div>
      </div>

      <div class="row compressedRow longListTextarea">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwReLlane2"> Resto llantas eje 2 </label>
            </div>
          </div>
          <div class="inputContainer extraHeightRow">
            <textarea
              id="pwReLlane2"
              type="textarea"
              formControlName="pwReLlane2"
              maxlength="128"
              maxlength="32"
              [readonly]="true"
            ></textarea>
          </div>
        </div>
      </div>

      <div class="row compressedRow">
        <div class="itemContainer col">
          <div class="seachLabel inputLabelContainer">
            <div class="inputLabel">
              <label for="pwTextNeum"> Comentario neumáticos </label>
            </div>
          </div>
          <div class="inputContainer">
            <input
              id="pwTextNeum"
              type="text"
              formControlName="pwTextNeum"
              maxlength="32"
              [readonly]="true"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="halfGroup">
      <div
        class="formGroupButtons detalleFormGroupButtonsFooter longDetailFooter"
      >
        <div class="formButton">
          <button
            *ngIf="!maintenancePatronesWltp.pristine"
            class="submitButton"
            type="button"
            [swal]="confirmSwal"
          >
            <em class="fas fa-caret-square-left"></em>
          </button>
          <button
            *ngIf="maintenancePatronesWltp.pristine"
            class="submitButton"
            type="button"
            (click)="goList()"
          >
            <em class="fas fa-caret-square-left"></em>
          </button>
        </div>

        <div class="middleButtonAceptarContainer notFullWidth">
          <div class="formButton">
            <button class="submitButton wideSubmitButton" type="submit">
              {{ "commons.ok" | translate }}
            </button>
          </div>
        </div>

        <swal
          #confirmSwal
          html="<strong>Tienes cambios sin guardar <br/> ¿Quieres volver sin guardar?</strong>"
          icon="warning"
          [showCancelButton]="true"
          [swalOptions]="{
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar',
            allowEscapeKey: false,
            allowOutsideClick: false
          }"
          [focusCancel]="true"
          (confirm)="goList()"
        >
        </swal>
      </div>
    </div>
  </form>
</div>
